import type { RouteConfig } from 'vue-router';
import { VueRouterOverride } from './navigation/override';
import { routeMain } from './routeMain';
import { routeTickets } from './routeTickets';
import { routeTopics } from './routeTopics';
import { routeCampaigns } from './routeCampaigns';
import { routeCommunity } from './routeCommunity';
import { routeWorkspace } from './routeWorkspace';
import { routeProfile } from './routeProfile';
import { routeSearch } from './routeSearch';
import { routeTeam } from './routeTeam';
import { routeServices } from './routeServices';
import { routeDigitalContent } from './routeDigitalContent';
import {
  authGuard,
  compatibilityGuard,
  completeProfileGuard,
  fallbackGuard,
  logoutGuard,
  preSubdomainGuard,
  resolveContextGuard
} from './navigation/guards';
import {
  applyTitleUpdater,
  resetAiAgentContext,
  sendKibanaPageEvent
} from './navigation/features';
import AppProvider from '../AppProvider.vue';
import AppError from '../AppError.vue';
import LogoutPage from '../views/LogoutPage.vue';

const routes: RouteConfig[] = [
  ...routeMain,
  ...routeCampaigns,
  ...routeTickets,
  ...routeTopics,
  ...routeCommunity,
  ...routeWorkspace,
  ...routeProfile,
  ...routeSearch,
  ...routeTeam,
  ...routeServices,
  ...routeDigitalContent
];

const main = [
  // Empty route configuration
  {
    path: '/',
    component: AppProvider
  },
  // Logout route
  {
    path: '/logout',
    name: 'LogoutPage',
    component: LogoutPage
  },
  // Error route
  {
    path: '/error/:errorCode',
    name: 'AppError',
    component: AppError,
    meta: {
      title: 'Error'
    }
  },
  // Standard route configuration
  {
    path: '/:product',
    component: AppProvider,
    children: [
      ...routes,
      {
        path: '/:pathMatch(.*)*',
        beforeEnter: fallbackGuard
      }
    ]
  }
];

const router = new VueRouterOverride({
  mode: 'history',
  routes: main
});

router.beforeEach(logoutGuard);
router.beforeEach(authGuard);
router.beforeEach(preSubdomainGuard);
router.beforeEach(resolveContextGuard);
router.beforeEach(completeProfileGuard);
router.beforeEach(compatibilityGuard);
router.beforeEach(sendKibanaPageEvent);
router.beforeEach(applyTitleUpdater);
router.beforeEach(resetAiAgentContext);
export default router;
